import React from "react";
import { useFormikContext } from "formik";
import { useNumberInputFilter, usePendingPrefill, useSetDefaultValue } from "../../hooks";
import { emptyFunction } from "../../utils/helpers/emptyFunction";
import { Input } from "./input";

export const PrefillInput = React.forwardRef((props, ref) => {
  const {
    name, title, placeholder, type, maxLength, inputMode, prefix, toolTipText, className, onBlur, inputRender, number, disabled, showErrorMessage = true
  } = props;
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  const handleNumberChange = useNumberInputFilter(name);

  useSetDefaultValue(name);
  usePendingPrefill(name);

  return (
    <Input
      ref={ref}
      disabled={disabled}
      title={title}
      placeholder={placeholder}
      onChange={!!number ? handleNumberChange : handleChange}
      onBlur={(event) => {
        handleBlur(event);
        (onBlur || emptyFunction)(event);
      }}
      value={values[name]}
      name={name}
      type={type}
      maxLength={maxLength}
      inputMode={inputMode}
      prefix={prefix}
      toolTipText={toolTipText}
      className={className}
      errorMessage={touched[name] ? errors[name] : ""}
      inputRender={inputRender}
      showErrorMessage={showErrorMessage}
    />
  );
});